module.exports = __webpack_public_path__ + "static/media/Siux_white.dc78cd15.png";